export default {
	USDT: 'USDT',
	保存并下次使用: '次回のために保存する',
	保存此卡以用于后续支付: '次回以降の支払いのためにこのカードを保存',
	操作: '操作する',
	操作失败: '操作に失敗しました',
	操作时间: '稼働時間',
	查看发票: '請求書を表示する',
	查看记录: '記録を見る',
	查看信用发票: 'クレジット請求書の表示',
	查看信用记录: '信用履歴を表示する',
	持卡人姓名: 'カード名義人',
	充值记录: '充電記錄',
	充值金额: '充電金額',
	充值提示: '{min}から{max}の範囲で整数を入力してください',
	创建时间: '作成時間',
	打印: '印刷する',
	打印时间: '印刷時間',
	到期: '有効期限',
	到期日期: '有効期限',
	订单编号: '注文番号',
	订单发票: '注文請求書',
	订单详情: '注文詳細',
	订单支付: '注文支払い',
	发票编号: '請求書番号',
	发票项目: '請求書項目',
	发票PDF: '請求書PDF',
	非常感谢您的付款已成功完成: 'ありがとうございます。お支払いが正常に完了しました',
	复制链接: 'リンクをコピー',
	复制失败: 'コピーに失敗しました',
	管理信用卡: 'カード管理',
	交易详情: '取引詳細',
	接收方: '受取人',
	金额: '額',
	金额已复制: '金額をコピーしました',
	进行实名认证: '本人確認へ',
	卡片保存成功: 'カードを保存しました',
	可用余额: '利用可能残高',
	类型: 'タイプ',
	立即充值: '今すぐ充電してください',
	链接已复制: 'リンクがコピーされました',
	登录提醒: 'ログインが必要です',
	描述: '説明する',
	默认: 'デフォルト',
	内容: 'コンテンツ',
	其它支付方式: 'その他のお支払い方法（カード、Alipay、WeChatなど）',
	请扫描二维码或点击金额和地址粘贴转账USDT支付: 'QRコードをスキャンするか、金額とアドレスをクリックしてコピーし、USDT(TRC-20) でお振込みください。',
	'请使用微信「扫一扫」': 'WeChatでQRコードをスキャンしてお支払いください',
	'请使用支付宝「扫一扫」': 'AlipayでQRコードをスキャンしてお支払いください',
	请输入持卡人姓名: 'カード名義人を入力',
	请输入发票编号: '請求書番号を入力してください',
	请先获取支付信息: '先に支払い情報を取得してください',
	请先登录后使用该支付方式: 'この支払い方法を利用するにはログインしてください',
	请先进行实名认证或提升实名认证等级: '本人確認を完了するか、認証レベルを上げてください',
	确认删除此卡吗: 'このカードを削除しますか？',
	去登录: 'ログインへ',
	删除此卡: 'カード削除',
	商品名称: '商品名',
	设为自动扣款: '自動引き落としに設定',
	生成日期: '生成日',
	生成时间: '生成時間',
	实名认证提醒: '本人確認のお願い',
	使用浏览器打开支付页面: 'ブラウザで支払いページを開く',
	使用新卡: '新しいカードを使用',
	使用信用卡: 'カードを使用',
	使用已保存的卡: '保存済みカードを使用',
	使用已保存的卡片: '保存済みカードを使用',
	输入新卡支付: '新しいカードを使用',
	拖动卡片进行排序: 'ドラッグして並べ替え',
	微信扫码支付: 'WeChatでQRコードをスキャンしてお支払いください',
	微信支付: 'WeChat',
	下载: 'ダウンロード',
	小计: '小計',
	新增信用卡: 'カード追加',
	信用发票: 'クレジット請求書',
	信用记录: '信用履歴',
	信用卡: 'カード',
	信用余额: 'クレジット残高',
	信用余额可用于后续平台的消费: 'クレジット残高は今後のプラットフォーム利用にご利用いただけます',
	选择支付方式: 'お支払い方法を選択',
	已过期: '支払いの有効期限が切れました',
	应付金额: '支払い金額',
	余额: 'バランス',
	余额不足: '残高不足です。チャージするか他の支払い方法を選択してください',
	账号概况: 'アカウントの概要',
	正在验证: '確認中...',
	支付: '支払う',
	支付宝: 'Alipay',
	支付成功: '支払いが成功しました',
	支付初始化失败: '支払い初期化に失敗しました',
	支付方式: '支払方法',
	支付金额: '支払い金額',
	支付日期: '支払日',
	支付失败: '支払い失敗',
	支付时间: '支払い時間',
	支付信息: '支払い情報',
	支付中: '処理中...',
	支付ID: '支払いID',
	转账金额必须为下方显示带小数点的金额: '振込金額は下に表示された小数点付きの金額にしてください。',
	转账金额必须为下方显示的金额且需要在倒计时内完成转账否则无法被系统确认:
		'振込金額は下に表示された金額と一致し、かつカウントダウン内に振込を完了してください。さもないとシステムで確認できません！',
	状态: '州',
	自定义: 'カスタム',
	自动扣款: '自動引き落とし',
	自动扣款中: '自動引き落とし中',
	总计: '合計',
	最低充值金额: '最低入金額 {金額}',
	USDT地址已复制: 'USDTアドレスがコピーされました',
}
